import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApicallService } from '../services/apicall.service';

@Injectable({
  providedIn: 'root'
})
export class PANNumberValidationGuard  {
  
  constructor( 
    private apiCallService: ApicallService,
    private router: Router
    ){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.apiCallService.user.is_pan_number_blank) {
        this.router.navigate(['/profile']) 
      }
      else if(this.apiCallService.user.approval_status!=0 &&  this.apiCallService.user.roles[0].type === 'agent' ){
        this.router.navigate(['/profile']) 
      }
    return true;
  }
  
}
